export var cookieKeys = {
  COUNTRY_COOKIE_KEY: 'NIKE_COMMERCE_COUNTRY',
  // example value: CH
  LANGUAGE_COOKIE_KEY: 'NIKE_COMMERCE_LANG_LOCALE',
  // example value: de_DE
  COMBINED_COOKIE_KEY: 'nike_locale',
  // example value: ch/de_de (a session cookie that seems to come from Akamai's geolocation)
  CHOICE_COOKIE_KEY: 'CONSUMERCHOICE',
  // example value: ch/de_de
  CHOSEN_COOKIE_KEY: 'CONSUMERCHOICE_SESSION' // example value: t (prevents the flag modal from appearing)

};
export var regexes = {
  countryRegex: /^[A-Z]{2}$/,
  legacyLanguageRegex: /^[a-z]{2}_[A-Z]{2}$/,
  combinedRegex: /^[a-z]{2}\/[a-z]{2}_[a-z]{2}$/
};